import {
  Typography,
  Tooltip,
  IconButton,
  ListItemText,
  ListItemButton,
  ListItemButtonBaseProps,
} from '@mui/material';

interface SidebarButtonProps extends ListItemButtonBaseProps {
  onClick: () => void;
  title: string;
  summary: number;
  expanded?: boolean;
}

export const SidebarButton: React.FC<SidebarButtonProps> = (props) => {
  const {
    summary,
    expanded = true,
    children,
    selected,
    title,
    onClick,
    ...rest
  } = props;
  return (
    <ListItemButton
      sx={{ pl: 1 }}
      onClick={onClick}
      disableGutters
      selected={selected}
      {...rest}
    >
      <Tooltip title={title} placement='top-end'>
        <span>
          <IconButton disabled={expanded}>{children}</IconButton>
        </span>
      </Tooltip>
      {expanded && (
        <>
          <ListItemText
            sx={{ ml: 1, mr: 2 }}
            style={{ whiteSpace: 'nowrap' }}
            primary={title}
          />
          <Typography sx={{ mr: 2 }} variant='subtitle1'>
            {summary}
          </Typography>
        </>
      )}
    </ListItemButton>
  );
};
